<template>
  <div class="forestPage">
    <div class="forestMap" v-if="param.showMap">
      <!-- 地图页 -->
      <map-locator :param="mapData" mode="h5"></map-locator>
    </div>
    <div
      :class="['forestTab', this.param.showMap == false ? 'SmallTab' : '']"
      id="forestTab"
    >
      <!-- 这是一个页面 -->
      <yzld-info :dataInfo="param"></yzld-info>
    </div>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const mapLocator = () => import("@/components/map/MapLocator");
const refreshPage = () => import("@/components/common/refreshPage");
const yzldInfo = () => import("@/components/yzldModule/yzldInfo");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "yzldMsg",
  data() {
    return {
      activeName: "zyldMsg", //默认选中第一项
      yzldId: "", //营造林地Id

      refreshPage: false,
      mapData: {
        type: "LAYER_TYPE_010",
        objid: "",
      },
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  components: {
    mapLocator,
    yzldInfo,
    refreshPage,
  },
  mounted() {
    document.title = "营造林地信息";
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.yzldId = this.$route.query.commonId;
      if (JSON.stringify(this.param) === "{}") {
        // this.param.showMap = true;
        // this.param.objid = this.yzldId;
        this.$set(this.param, "showMap", true);
        this.$set(this.param, "objid", this.yzldId);
      }
      this.$set(this.mapData, "objid", this.yzldId);
    });
  },

  methods: {},
};
</script>
<style lang="less">
.forestPage {
  width: 100%;
  height: 100%;
  .forestMap {
    width: 100%;
    height: 40%;
    > div {
      height: 100%;
    }
  }
  .forestTab {
    width: 100%;
    height: 60%;
    background-color: #fff;
    overflow-y: scroll;
  }
  .forestTab.SmallTab {
    height: 100%;
    background-color: #fff;
    overflow-y: scroll;
  }
}
</style>